// mui
import { Box, SxProps } from '@mui/material';

// img
import { LogoFundsChainMark } from '../../img/LogoFundsChainMark';

// theme
import { theme } from '../../../theme';

// props
export interface CubeProps {
	hasLogoMark?: boolean;
	size?: number;
}

export const Cube = ({ hasLogoMark = true, size = 30 }) => {
	// vars
	const sizeHalf = size / 2;

	const sxSide: SxProps = {
		width: size,
		height: size,
		lineHeight: `${size}px`,
		backgroundColor: theme.palette.brand.blue[500],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
	};

	const sxTop: SxProps = {
		...sxSide,
		backgroundColor: theme.palette.brand.blue[600],
		transform: 'rotateX(90deg)',
		marginTop: `-${sizeHalf}px`,
	};

	const sxRight: SxProps = {
		...sxSide,
		transform: 'rotateY(90deg)',
		marginLeft: `${sizeHalf}px`,
	};

	const sxBottom: SxProps = {
		...sxSide,
		backgroundColor: theme.palette.brand.blue[600],
		transform: 'rotateX(-90deg)',
		marginTop: `${sizeHalf}px`,
	};

	const sxLeft: SxProps = {
		...sxSide,
		transform: 'rotateY(-90deg)',
		marginLeft: `-${sizeHalf}px`,
	};

	const sxFront: SxProps = {
		...sxSide,
		backgroundColor: theme.palette.brand.blue[800],
		transform: `translateZ(${sizeHalf}px)`,
	};

	const sxBack: SxProps = {
		...sxSide,
		backgroundColor: theme.palette.brand.blue[800],
		transform: `translateZ(-${sizeHalf}px) rotateX(180deg)`,
	};

	return (
		<Box
			sx={() => {
				return {
					transformStyle: 'preserve-3d',
					animation: 'spin 3s infinite linear',
					width: size,
					height: size,
				};
			}}>
			<Box sx={sxTop} />
			<Box sx={sxRight} />
			<Box sx={sxBottom} />
			<Box sx={sxLeft} />
			<Box sx={sxFront}>
				{hasLogoMark && (
					<LogoFundsChainMark
						style={{ display: 'inline-flex !important', width: '60%', height: 'auto' }}
					/>
				)}
			</Box>
			<Box sx={sxBack} />
		</Box>
	);
};
